/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:37:08
 */

import MaintenanceRecord from '../maintenanceRecord';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import MaintenanceRecordApi, { MaintenanceRecordDOI } from '../api/maintenanceRecordApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import EnumOperates from 'src/enums/enumOperates';
import alertOperateMaintenanceRecordModal from '../operateMaintenanceRecordModal';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import Input from 'src/types/iview/Input';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import FileUtil from 'src/util/fileUtil';

export default class MaintenanceRecordService extends ListPageService {
    ctx: MaintenanceRecord;

    constructor(ctx: MaintenanceRecord) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '处理单号',
                field: 'record_number',
                minWidth: 140,
            },
            {
                headerName: '处理人',
                field: 'dispose_people',
                minWidth: 100,
            },
            {
                headerName: '处理时间',
                field: 'dispose_datetime',
                minWidth: 170,
            },
            {
                headerName: '处理站点',
                field: 'dispose_site',
                minWidth: 140,
            },
            {
                headerName: '处理类型',
                field: 'dispose_type',
                minWidth: 100,
            },
            {
                headerName: '处理内容',
                field: 'dispose_content',
                minWidth: 140,
            },
            {
                headerName: '文件链接',
                field: 'accessory',
                minWidth: 140,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 220,
                maxWidth: 220,
                // pinned: 'right',
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: MaintenanceRecordDOI.RowDataI = params.data;
                            let res = await alertOperateMaintenanceRecordModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: MaintenanceRecordDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                    {
                        text: '预览',
                        click: t.preview.bind(t),
                    },
                    {
                        text: '下载',
                        click: t.download.bind(t),
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '处理类型',
                field: 'dispose_type',
                props: {
                    value: null,
                    type: EnumEntity.DeclareType.getId()
                },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

    async preview(params) {
        let list: Array<any> = params.data.accessory.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlPreviewFile(url);
            }
        });
    }

    async download(params) {
        let list: Array<any> = params.data.accessory.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlDownloadFile(url, DateTimeUtil.GMTToStr());
            }
        });
    }

    async delete(ids: number[]) {
        let { code } = await MaintenanceRecordApi.delete({ ids });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<MaintenanceRecordDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertOperateMaintenanceRecordModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
            {
                text: '删除',
                type: 'info',
                async onClick() {
                    let gridOptions: any = t.ctx.gridOptions;
                    let selectRows: MaintenanceRecordDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                    if (selectRows.length === 0) {
                        return Toast.warning('请选择要操作的数据');
                    }
                    let res = await Toast.confirm();
                    if (!res) {
                        return;
                    }
                    let ids: number[] = selectRows.map(item => item.id);
                    await t.delete(ids);
                },
            },
        ];
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await MaintenanceRecordApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
